import Search from "/components/shared/Search";
import ViewButton from "/components/shared/buttons/ViewButton";


export default function SubViewHeader({label, icon, buttonLabel, url}) {

    return (
        <div className="flex flex-col w-fit 2xl:flex-row 2xl:items-center justify-between p-2 ml-2 xl:ml-0">
            <div className="text-lg 2xl:text-xl my-1 font-cooper text-black ">
                <h4>{label}</h4>
            </div>
            <div className='hidden 2xl:block'>
                <Search/>
            </div>
            <div className='xl:flex xl:justify-between'>
                <div className='2xl:hidden'>
                    <Search/>
                </div>
                <div className='flex justify-between pt-2 xl:pt-0 xl:ml-8 2xl:mx-0 2xl:px-4 '>
                    <ViewButton href={url} className='p-1 my-1 pt-2 px-6 2xl:pt-2 2xl:pb-1 h-8 2xl:px-4 2xl:mr-12'
                                icon={icon}>
                        {buttonLabel}
                    </ViewButton>
                </div>

            </div>
        </div>
    )
}
